import React, { Component } from 'react';
import { connect } from 'react-redux';
import NewsAPI from '../../api/NewsAPI';
import Loading from '../helpers/Loading.jsx';
import Image from '../helpers/Image.jsx';
import uuid from 'uuid';
import Paper from 'material-ui/Paper';
import moment from 'moment';
import './News.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
  }
}

class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      articles: undefined
    };
  }

  goToUrl(url) {
    window.open(url,'_blank');
  }

  componentDidMount() {
    NewsAPI.getNews((news) => {
      let articles = news.articles.slice(0, 4);
      this.setState({
        articles: articles,
        loading: false
      })
    });
  }

  renderLoading() {
    return <Loading />
  }

  renderNews() {
    const {
      articles
    } = this.state;

    const {
      fonts,
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name
      },
      secondaryFont: {
        fontFamily: secondary.name
      }
    }

    return (
      <div>
        {articles.map((article) => {
          return (
            <Paper
              zDepth={1}
              key={uuid.v4()}
              className="article-container"
              onClick={() => this.goToUrl(article.url)}>
              <Image src={article.urlToImage} className="article-image" />
              <div className="article-content-container">
                <div className="article-headline" style={styles.primaryFont}>
                  {article.title}
                </div>
                <div className="article-published">
                  Published {moment(article.publishedAt).format('MMMM Do YYYY')}
                </div>
                <div className="article-description" style={styles.secondaryFont}>
                  {article.description}
                </div>
              </div>
            </Paper>
          )
        })}
      </div>
    );


  }

  render() {
    const {
      loading
    } = this.state;

    const {
      fonts,
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name
      },
      secondaryFont: {
        fontFamily: secondary.name
      }
    }

    return (
      <div>
        <div className="divider-wrapper">
          <div className="divider">
            <span style={styles.secondaryFont}>Today's headlines</span>
          </div>
        </div>
        <div className="news-wrapper">
          {loading
            ? this.renderLoading()
            : this.renderNews()}
        </div>
      </div>
    )
  }
}

export default News = connect(mapStateToProps, undefined)(News);



// WEBPACK FOOTER //
// ./src/components/generator/News.jsx